<azavista-table *ngIf="loaded" [dataSource]="data" [columns]="columns" [displayedColumns]="displayedColumns"
    [compactControls]="true"
    [pagingOptions]="pagingOptions">
</azavista-table>
